import { reactive, readonly } from 'vue'
import apiService from '@/services/api.service'
import Mobility from '@/types/Mobility.interface'

type DriversLicenseSelection = 'yes' | 'in_progress' | 'no' | null

interface MobilityState {
  mobility: Mobility
  driversLicenseSelection: DriversLicenseSelection
  loading: boolean
  error: string | null
  fetched: boolean
}

const state = reactive<MobilityState>({
  mobility: {
    hasCar: null,
    hasDriversLicense: null,
    maxCommuteTimeInMinutes: null,
    maxDistanceInKm: null,
  },
  driversLicenseSelection: null,
  loading: false,
  error: null,
  fetched: false,
})

const fetchMobility = async (force = false) => {
  if (state.fetched && !force) return

  state.loading = true
  state.error = null

  try {
    const { data } = await apiService.mobility.get()
    state.mobility = data.mobility
    state.fetched = true
  } catch (e: unknown) {
    const errorMessage =
      e instanceof Error ? e.message : 'Failed to load mobility'
    state.error = errorMessage
    console.error(e)
  } finally {
    state.loading = false
  }
}

const updateMobility = async (params: Partial<Mobility>) => {
  state.loading = true
  state.error = null

  try {
    const { data } = await apiService.mobility.patch(params)
    state.mobility = data.mobility
  } catch (e: unknown) {
    const errorMessage =
      e instanceof Error ? e.message : 'Failed to update mobility'
    state.error = errorMessage
    console.error(e)
    throw e
  } finally {
    state.loading = false
  }
}

const setMobility = (data: Mobility) => {
  state.mobility = data
  state.fetched = true
}

const setDriversLicenseSelection = (selection: DriversLicenseSelection) => {
  state.driversLicenseSelection = selection
}

export default {
  state: readonly(state),
  fetchMobility,
  updateMobility,
  setMobility,
  setDriversLicenseSelection,
}
